import React, { FunctionComponent } from 'react';
import ContentStyle                 from './Content.style';
import { LayoutProps }              from 'antd';

type TProps = LayoutProps

export const Content: FunctionComponent<TProps> = ({ children }) => {

  return (
    <ContentStyle>
      {children}
    </ContentStyle>
  );

};
